import React from 'react';
import { rgba } from 'polished';
import SVG from 'react-inlinesvg';
import PropTypes from 'prop-types';

import DevolutionVideoThumbnail from '../../../../assets/images/clique-retire-devolution.jpg';
import PlayIcon from '../../../../assets/icons/Play.svg';
import { Text, Spacer } from '../../../../shared/components';

export default function DemoVideoCard({ videoClickCallback }) {
  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
      }}
    >
      <div
        style={{
          position: 'relative',
          width: '40%',
          cursor: 'pointer',
        }}
        onClick={videoClickCallback}
      >
        <img
          src={DevolutionVideoThumbnail}
          alt="Thumbnail do vídeo de demonstração"
          style={{
            width: '100%',
            height: '100%',
            maxHeight: '100px',
            objectFit: 'cover',
            borderRadius: 2,
          }}
        />
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '32px',
            height: '32px',
            zIndex: 1,
            backgroundColor: '#ffffff',
            borderRadius: '50%',
          }}
        />
        <SVG
          className="svg"
          src={PlayIcon}
          width={40}
          color="var(--color-blue-primary)"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 2,
          }}
        />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'flex-start',
          boxSizing: 'border-box',
          padding: '10px 15px',
          width: '60%',
          maxHeight: '100px',
          backgroundColor: '#FFC4001A',
          borderRadius: 2,
          borderRight: '1px solid',
          borderTop: '1px solid',
          borderBottom: '1px solid',
          borderColor: rgba('#FFC400', 0.4),
        }}
      >
        <Text.h4>Assista ao vídeo tutorial</Text.h4>
        <Spacer.vertical size={10} />
        <Text.small weak>
          Clique no link para assistir ao tutorial de como configurar sua conta
        </Text.small>
      </div>
    </div>
  );
}

DemoVideoCard.propTypes = {
  videoClickCallback: PropTypes.func.isRequired,
};
